import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM8.63 25.389l1.28-3.84c-1.106-1.637-1.507-3.575-1.126-5.454.38-1.88 1.515-3.572 3.194-4.763 1.679-1.191 3.787-1.8 5.933-1.713 2.145.087 4.183.864 5.732 2.186 1.55 1.322 2.507 3.1 2.694 5.001.186 1.902-.411 3.8-1.68 5.34-1.27 1.54-3.125 2.618-5.222 3.033-2.097.416-4.291.14-6.176-.775l-4.63.985Zm13.556-9.366a.906.906 0 0 1-.251 1.256l-2.955 1.97a.906.906 0 0 1-1.143-.113l-1.444-1.445-2.337 1.558a.906.906 0 0 1-1.005-1.508l2.954-1.97a.906.906 0 0 1 1.144.114l1.444 1.444 2.336-1.557a.906.906 0 0 1 1.257.25Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgMessenger;